import React from "react";
import CopyToClipboardIcon from "./CopyToClipboardIcon";
import { faCopy } from "@fortawesome/pro-light-svg-icons";

interface CopyToClipboardIconWrapperProps {
	text: string;
	lastCopiedText: string;
	setLastCopiedText?: (text: string) => void;
	iconStyles?: string;
	withText?: boolean;
	copyText?: string;
	hasIconBorder?: boolean;
	onClick?: () => void;
}

const CopyToClipboardIconWrapper: React.FC<CopyToClipboardIconWrapperProps> = ({
	text,
	lastCopiedText,
	setLastCopiedText,
	iconStyles = "",
	withText = false,
	copyText,
	hasIconBorder = true,
	onClick = () => {},
}) => {
	return (
		<div className={iconStyles}>
			<CopyToClipboardIcon
				copyText={copyText}
				icon={faCopy}
				withText={withText}
				additionalClasses="border-1 border-primary p-1  rounded-full"
				text={text}
				copied={lastCopiedText === text}
				onCopy={() => setLastCopiedText && setLastCopiedText(text)}
				hasIconBorder={hasIconBorder}
				onClick={onClick}
			/>
		</div>
	);
};

export default CopyToClipboardIconWrapper;
